export type AdminSummary = {
  sellers_total?: number;
  leads_total?: number;
  leads_open?: number;
  wins_total?: number;
  wins_in_period?: number;
  activities_total?: number;
  messages_sent?: number;
  messages_received?: number;
  leads_contacted?: number;
  leads_responded?: number;
  response_rate?: number;
};

export type AdminSellerMetric = {
  seller_id: number;
  seller_email: string;
  activities_total?: number;
  messages_sent?: number;
  messages_received?: number;
  leads_contacted?: number;
  leads_responded?: number;
  response_rate?: number;
  wins_in_period?: number;
  wins_total?: number;
  leads_total?: number;
  leads_open?: number;
  last_activity_at?: string | null;
};

export type AdminDashboard = {
  days: number;
  summary: AdminSummary;
  by_seller: AdminSellerMetric[];
};

export type AdminUser = {
  id: number;
  email: string;
  role: string;
  leads_total?: number;
  leads_open?: number;
  last_seen_at?: string | null;
};

export type AdminImportBatch = {
  id: number;
  filename: string;
  status: string;
  import_tag?: string;
  total_rows: number;
  imported_count: number;
  duplicate_count: number;
  invalid_count: number;
  pending_count?: number;
  assigned_count?: number;
  created_at: string;
};

export type AdminDuplicatePair = {
  user_email?: string;
  real_name?: string;
  phantom_name?: string;
  phone?: string;
  email?: string;
  reason?: string;
};

export type AdminWhatsappAccount = {
  sessionId: string;
  label?: string;
  provider?: string;
  accountType?: string;
  status?: string;
  pushName?: string;
  ownerUserId: number;
  ownerEmail: string;
};

export type AdminUserAccess = {
  userId: number;
  owned: AdminWhatsappAccount[];
  grantedSessionIds: string[];
};

export type AssignForm = {
  seller_email: string;
  name: string;
  phone: string;
  email: string;
  course: string;
  notes: string;
  priority: "Alta" | "Media" | "Baixa";
};

export const EMPTY_ASSIGN_FORM: AssignForm = {
  seller_email: "",
  name: "",
  phone: "",
  email: "",
  course: "",
  notes: "",
  priority: "Media",
};
